export enum DisturbanceInfoType {
  Malfunction = "Malfunction",
  Elevator = "Elevator",
}
